import { Button } from "@sellar-io/components";
import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import { Alert } from "../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { useXeroCreateFailedInvoice } from "../../../hooks/api/v2/xero/useXeroCreateFailedInvoice";
import { sanitizeEmailArray } from "@sellar-io/common";

export function XeroInvoiceDialog({
  active,
  onDismiss,
  order,
}: {
  active: boolean;
  onDismiss: () => void;
  order: OrderGetResponseType;
}): ReactElement {
  const mutation = useXeroCreateFailedInvoice();

  const onConfirm = () => {
    if (!order.Retailer.Business || !order.Supplier.Business) throw new Error();

    if (!order.paymentDue) throw new Error("paymentDueDate is required");
    const sanitizedBusinessInvoiceEmails = sanitizeEmailArray(
      order.Retailer.Business.invoiceEmails,
    );
    mutation.mutate(
      {
        RetailerId: order.RetailerId,
        supplierId: order.SupplierId,
        retailerName: order.Retailer.Business.name,
        supplierName: order.Supplier.Business.name,
        orderId: order.id,
        paymentDueDate: order.paymentDue,
        paymentStatus: order.paymentStatus,
        invoiceEmailAddresses: order.retailerInvoiceEmails
          ? order.retailerInvoiceEmails
          : sanitizedBusinessInvoiceEmails.length > 0
            ? sanitizedBusinessInvoiceEmails
            : [order.Retailer.Business.email],
      },
      {
        onSuccess: () => onDismiss(),
      },
    );
  };
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={"Admin create invoice for xero"}
        description={
          "This will create an invoice on xero - Please ensure this is not a duplicate"
        }
        onClickLeftIcon={() => onDismiss()}
        leftIcon={"CHEVRON_DOWN"}
      />
      <DialogContent>
        {mutation.isError ? (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(mutation.error)?.response?.data.message ??
              "Unknown error"
            }
          />
        ) : null}
      </DialogContent>
      <DialogCTA>
        <Button onClick={onConfirm} loading={mutation.isPending}>
          Create invoice
        </Button>
      </DialogCTA>
    </Dialog>
  );
}
